import { Card, CardContent } from '@repo/shadcn';
import { format } from 'date-fns';
import { Bell, Calendar, Package } from 'lucide-react';

import { useStockDetails } from '@/modules/stocks/stock-product-details/stock-product-details.hook';

export const StockOverview = () => {
    const { data, isLoading, isFetching } = useStockDetails();

    if (isLoading || isFetching) {
        return <div>Loading...</div>;
    }

    return (
        <div className="grid grid-cols-3 gap-4">
            {/* Total Stock Card */}
            <Card>
                <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-muted-foreground">
                            Total Stock
                        </span>
                        <Package className="h-4 w-4 text-blue-500" />
                    </div>
                    <div className="mt-2 text-3xl font-bold">
                        {data?.data?.current_stock || 'N/A'}
                    </div>
                    <p className="mt-1 text-xs text-muted-foreground">
                        Units available
                    </p>
                </CardContent>
            </Card>

            {/* Low Stock Alert Card */}
            <Card className="">
                <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                        <span className="text-sm font-medium ">
                            Total Batches
                        </span>
                        <Bell className="h-4 w-4 " />
                    </div>
                    <div className="mt-2 flex items-center gap-2">
                        <span className="text-3xl font-bold ">
                            {data?.data?.current_batches || 'N/A'}
                        </span>
                        {/*<span className="x-2 rounded-md py-0.5 text-xs font-medium ">*/}
                        {/*    Batches*/}
                        {/*</span>*/}
                    </div>
                    <p className="mt-1 text-xs ">Available Batches</p>
                </CardContent>
            </Card>

            {/* Nearest Expiry Card */}
            <Card>
                <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-muted-foreground">
                            Nearest Expiry
                        </span>
                        <Calendar className="h-4 w-4 text-red-500" />
                    </div>
                    <div className="mt-2 text-3xl font-bold">
                        {data?.data?.nearest_expiration
                            ? format(
                                  data?.data?.nearest_expiration,
                                  'MMM dd, yyyy',
                              )
                            : 'N/A'}
                    </div>
                    {/*<p className="mt-1 text-xs text-red-500">*/}
                    {/*    Expires in 14 days*/}
                    {/*</p>*/}
                </CardContent>
            </Card>
        </div>
    );
};

StockOverview.displayName = 'StockOverview';
